import React from 'react';
import {
  InputGroup,
  Input,
  InputGroupAddon,
  Button,
} from 'reactstrap'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from 'react-i18next';


export function SearchInput(props) {
  const { t } = useTranslation();
  return (
    <InputGroup>
      <Input 
          placeholder={t('forms.search')}
          className={`align-self-center `}
          {...props}
      /> 
      <InputGroupAddon addonType="append">
        <Button size="sm" color="accent-100">
            <FontAwesomeIcon icon="search" />
        </Button>
      </InputGroupAddon>
    </InputGroup>
  )
}